import { observer } from 'mobx-react';
import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';
import { appStore } from 'src/mobx/appStore';
import { localeStore } from 'src/mobx/localesStore';
import './style.scss';

interface IProps {
  title: string;
  isBeta?: boolean;
}

const HeaderTitle: FC<IProps> = observer((props: IProps): JSX.Element => {
  return (
    <div className="header-title">
      <h1 className="header-title__title">
        {!appStore.timestamp || !localeStore.localizationLoaded ? <Skeleton width={300} /> : localeStore.t(props.title)}
      </h1>
    </div>
  );
});

export default HeaderTitle;
